
        if (import.meta.env.VITE_APP_SHOULD_USE_BEAMER === "true") {
          const script = document.createElement("script");
          script.src = "https://app.getbeamer.com/js/beamer-embed.js";
          script.defer = true;
          document.head.appendChild(script);
        }
      